module.exports = __webpack_public_path__ + "img/郭建淼.571fdea1.jpg";